import { useState, useEffect, useCallback } from "react";

export function useVersionCheck(currentVersion, checkInterval = 600000) {
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const [remoteVersion, setRemoteVersion] = useState(null);

    const checkForUpdate = useCallback(async () => {
        try {
            const response = await fetch("/version.json?t=" + new Date().getTime());

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const latestVersion = data.version;

            if (latestVersion && latestVersion !== currentVersion) {
                setRemoteVersion(latestVersion);
                setIsUpdateAvailable(true);
                console.log(
                    `New version available: ${latestVersion} (Current: ${currentVersion})`,
                );
            }
        } catch (error) {
            console.error("Failed to check for updates:", error);
        }
    }, [currentVersion]);

    useEffect(() => {
        checkForUpdate();

        const intervalId = setInterval(checkForUpdate, checkInterval);

        const onFocus = () => checkForUpdate();
        window.addEventListener("focus", onFocus);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener("focus", onFocus);
        };
    }, [checkForUpdate, checkInterval]);

    const reloadToUpdate = useCallback(() => {
        window.location.reload();
    }, []);

    return { isUpdateAvailable, remoteVersion, reloadToUpdate };
}
